/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { ExplanationForm } from "./ExplanationForm";

export const ExplanationColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { absenteeismValues, setAbsenteeismValues }
) => (
  <ExplanationForm
    id={row.id}
    parentId={row.parentId}
    studentName={row.studentName}
    absenteeismValues={absenteeismValues}
    setAbsenteeismValues={setAbsenteeismValues}
  />
)